import axios, { AxiosError } from 'axios';
import { nonFatalBuildError } from 'helpers/errorReporting';
import { getRecaptchaToken } from 'helpers/reCaptchaHelper';
import { destinations } from './destinations';
import { FormDataType } from './types';

const formsApiUrl = process.env.GATSBY_FORMS_API_URL;

const isAxiosError = (err: unknown): err is AxiosError => !!(err as AxiosError).response;

export const submitContactApi = async (
  answers: FormDataType,
  destinationCode: string,
  onSuccess?: () => void,
  onError?: () => void
): Promise<void> => {
  if (!formsApiUrl) {
    nonFatalBuildError(
      'Environemnt value missing!',
      'No value present for the forms API.'
    );
  }
  const formBody = answers;
  const { emailAddress } = formBody;

  if (emailAddress) {
    delete formBody.emailAddress;
  }

  const apiDestinationCode: string = destinations[destinationCode] ?? '';

  const recaptchaToken = await getRecaptchaToken();

  const body = {
    destinationCode: apiDestinationCode,
    emailAddress,
    fields: formBody,
    recaptchaToken,
  };

  try {
    await axios.post(`${formsApiUrl}`, JSON.stringify(body), {
      headers: { 'Content-Type': 'application/json' },
    });
    onSuccess?.();
  } catch (err) {
    /* istanbul ignore if */
    if (isAxiosError(err)) {
      console.error(`API request failed with status ${err.response?.status}`);
      console.info(err.response?.data);
      onError?.();
    }
  }
};
